export default __webpack_public_path__ + "static/media/Meebit_16844.5889f474.webp";